import RestApiModel from "@/api/Model/RestApiModel";

class DashboardPolicyProduction extends RestApiModel {
  static getResourceEndpoint() {
    return '/DashboardPolicyProduction';
  }
}

export default DashboardPolicyProduction;
